import ButtonMoreMenu from "@/components/Assessments/ButtonMoreMenu";
import SubCategoryCount from "@/components/Assessments/SubCategoryCount";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { FormValues } from "@/schema/console/assessments/create/FormValues";
import { CheckmarkRegular } from "@fluentui/react-icons";
import { useController, useFormContext, useWatch } from "react-hook-form";
import { twJoin } from "tailwind-merge";

interface CategoryPreviewProps {
  index: number;
  onRemove: () => void;
}

function CategoryPreview({ index, onRemove }: CategoryPreviewProps) {
  const { control, setValue } = useFormContext<FormValues>();

  const id = useWatch({
    control,
    name: `categories.${index}.id`,
  });

  const isEdit = useWatch({
    control,
    name: `categories.${index}.isEdit`,
  });

  const content = useWatch({
    control,
    name: `categories.${index}.content`,
  });

  const selectedCategory = useWatch({
    control,
    name: "selectedCategory",
  });

  const { field: contentField } = useController({
    control,
    name: `categories.${index}.content`,
  });

  return (
    <div
      onClick={() => {
        if (isEdit) return;
        setValue(`selectedCategory`, id);
      }}
      className={twJoin(
        selectedCategory === id && "rounded-md bg-cool-gray-100",
        "flex cursor-pointer items-start justify-between gap-3 py-2 pl-3",
      )}
    >
      <div className="flex flex-col gap-1">
        {isEdit ? (
          <Input
            {...contentField}
            autoFocus
            placeholder="Category name"
            // onKeyDown={(e) => {
            //   if (e.key === "Enter") {
            //     setValue(`categories.${index}.isEdit`, false);
            //   }
            // }}
          />
        ) : (
          <div className="font-medium text-cool-gray-600">{content}</div>
        )}
        <SubCategoryCount categoryIndex={index} />
      </div>
      <div className="flex gap-1">
        {isEdit ? (
          <Button
            onClick={() => setValue(`categories.${index}.isEdit`, false)}
            variant="secondary"
            size="icon"
          >
            <CheckmarkRegular fontSize={20} />
          </Button>
        ) : (
          <ButtonMoreMenu
            onEdit={() => setValue(`categories.${index}.isEdit`, true)}
            onDelete={onRemove}
          />
        )}
      </div>
    </div>
  );
}

export default CategoryPreview;
